import React from "react";

export const ImageIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.875 3.125H3.125C2.79348 3.125 2.47554 3.2567 2.24112 3.49112C2.0067 3.72554 1.875 4.04348 1.875 4.375V15.625C1.875 15.9565 2.0067 16.2745 2.24112 16.5089C2.47554 16.7433 2.79348 16.875 3.125 16.875H16.875C17.2065 16.875 17.5245 16.7433 17.7589 16.5089C17.9933 16.2745 18.125 15.9565 18.125 15.625V4.375C18.125 4.04348 17.9933 3.72554 17.7589 3.49112C17.5245 3.2567 17.2065 3.125 16.875 3.125ZM16.875 4.375V12.4023L14.8383 10.3664C14.7222 10.2503 14.5844 10.1582 14.4327 10.0954C14.281 10.0325 14.1185 10.0002 13.9543 10.0002C13.7901 10.0002 13.6276 10.0325 13.4759 10.0954C13.3242 10.1582 13.1864 10.2503 13.0703 10.3664L11.5078 11.9289L8.07031 8.49141C7.83592 8.25716 7.5181 8.12558 7.18672 8.12558C6.85534 8.12558 6.53752 8.25716 6.30312 8.49141L3.125 11.6695V4.375H16.875ZM3.125 13.4375L7.1875 9.375L13.4375 15.625H3.125V13.4375ZM16.875 15.625H15.2055L12.393 12.8125L13.9555 11.25L16.875 14.1703V15.625ZM11.25 7.8125C11.25 7.62708 11.305 7.44582 11.408 7.29165C11.511 7.13748 11.6574 7.01732 11.8287 6.94636C12 6.87541 12.1885 6.85684 12.3704 6.89301C12.5523 6.92919 12.7193 7.01848 12.8504 7.14959C12.9815 7.2807 13.0708 7.44775 13.107 7.6296C13.1432 7.81146 13.1246 7.99996 13.0536 8.17127C12.9827 8.34257 12.8625 8.48899 12.7083 8.592C12.5542 8.69502 12.3729 8.75 12.1875 8.75C11.9389 8.75 11.7004 8.65123 11.5246 8.47541C11.3488 8.2996 11.25 8.06114 11.25 7.8125Z"
      fill="#FAFAFA"
    />
  </svg>
);

export const FocusIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M10.5003 18.3334C15.1027 18.3334 18.8337 14.6025 18.8337 10.0001C18.8337 5.39771 15.1027 1.66675 10.5003 1.66675C5.89795 1.66675 2.16699 5.39771 2.16699 10.0001C2.16699 14.6025 5.89795 18.3334 10.5003 18.3334Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8333 10H15.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.50033 10H2.16699"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 5.00008V1.66675"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 18.3333V15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="Info">
      <path
        id="Vector"
        d="M7.5 7.5C7.63261 7.5 7.75979 7.55268 7.85355 7.64645C7.94732 7.74021 8 7.86739 8 8V10.5C8 10.6326 8.05268 10.7598 8.14645 10.8536C8.24021 10.9473 8.36739 11 8.5 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M7.75 5.875C8.09518 5.875 8.375 5.59518 8.375 5.25C8.375 4.90482 8.09518 4.625 7.75 4.625C7.40482 4.625 7.125 4.90482 7.125 5.25C7.125 5.59518 7.40482 5.875 7.75 5.875Z"
        fill={color}
      />
      <path
        id="Vector_3"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
